/** The Connect an editor page's queries (spec 236). */
export const editorAccessKeys = {
  discovery: () => ['editor-access', 'discovery'] as const,
  // The same answer, read without reporting a failure (spec 248).
  quietDiscovery: () => ['editor-access', 'discovery', 'quiet'] as const,
  myTools: () => ['editor-access', 'my-tools'] as const,
};
